import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ConsultaCnpjResponse } from '../../responses/pessoa/consulta-cnpj.response';


@Injectable({
  providedIn: 'root',
})
export class ConsultaCnpjService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  private readonly apiUrl = `${environment.urlApiPessoa}ConsultaCnpj/`;

  // Controller: [HttpGet("cnpj/{cnpj}")]
  public consultarCnpj(cnpj: string): Observable<ConsultaCnpjResponse> {
    return this.httpClient
      .get<ConsultaCnpjResponse>(
        this.apiUrl + `cnpj/${cnpj}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}